import React, { useEffect, useState } from 'react';
import { apiService } from '../../services/api';

const StatCard: React.FC<{ label: string; value: React.ReactNode }>= ({ label, value }) => (
  <div style={{ 
    padding: '1.25rem', 
    borderRadius: 16, 
    border: '1px solid rgba(0,0,0,0.08)', 
    background: '#fff',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    gap: '0.5rem'
  }}>
    <div style={{ fontSize: 28, fontWeight: 800, color: '#111827' }}>{value}</div>
    <div style={{ color: '#6b7280', fontSize: 12, textTransform: 'uppercase', fontWeight: 600, letterSpacing: '0.05em' }}>{label}</div>
  </div>
);

const StudentStatistics: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string|null>(null);
  const [data, setData] = useState<any>(null);

  const load = async () => {
    setLoading(true); setError(null);
    try {
      const resp = await apiService.get<any>('/api/lessons/statistics/student');
      const d = (resp && (resp.data || resp)) ? (resp.data || resp) : {};
      setData(d);
    } catch (e: any) {
      setError(e?.message || 'Failed to load statistics');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  return (
    <div style={{ padding: 24, minHeight: '100vh', background: '#ffffff' }}>
      <h1 style={{ fontSize: 28, margin: '0 0 1rem' }}>Your Statistics</h1>
      {error && (
        <div style={{ background: 'rgba(252,74,26,0.1)', border: '1px solid rgba(252,74,26,0.25)', color: '#8a1b0a', padding: 12, borderRadius: 10, marginBottom: 12 }}>{error}</div>
      )}
      {loading && <div>Loading…</div>}
      {!loading && (
        <div style={{ display: 'grid', gap: 12, gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))' }}>
          <StatCard label="Completed Lessons" value={data?.completedCount ?? '—'} />
          <StatCard label="Upcoming Lessons" value={data?.upcomingCount ?? '—'} />
          <StatCard label="Average Grade Received" value={typeof data?.averageTeacherGrade === 'number' ? data.averageTeacherGrade.toFixed(2) : '—'} />
        </div>
      )}
    </div>
  );
};

export default StudentStatistics;
